import { render, staticRenderFns } from "./input-tag.vue?vue&type=template&id=79390c58&scoped=true&"
import script from "./input-tag.vue?vue&type=script&lang=js&"
export * from "./input-tag.vue?vue&type=script&lang=js&"
import style0 from "./input-tag.vue?vue&type=style&index=0&id=79390c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79390c58",
  null
  
)

export default component.exports